import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/admin/moderation')({
  ssr: false,
})
